// extracted by mini-css-extract-plugin
export var blockedMessage = "_bg-3";
export var blockedOverlay = "_bg-1";
export var fadeIn = "_bg-2";
export var hereLink = "_bg-0";
export var slideUp = "_bg-4";